import { render, staticRenderFns } from "./DestroyInventory.vue?vue&type=template&id=5d09baa7&"
import script from "./DestroyInventory.vue?vue&type=script&lang=js&"
export * from "./DestroyInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports